import { t } from '@lingui/macro'
import SelectInput from '@/components/ui/inputs/SelectInput'
import { MeasurementUnitSystem, useMeasurementUnitSystem } from '@/hooks/useMeasurementUnitSystem'

export function UnitSystem() {
  const { unitSystem, setUnitSystem } = useMeasurementUnitSystem()

  return (
    <SelectInput
      fullWidth
      options={[
        { label: t`Metric`, value: 'metric' },
        { label: t`Imperial`, value: 'imperial' },
      ]}
      value={unitSystem}
      onChange={(e) => setUnitSystem(e.target.value as MeasurementUnitSystem)}
    />
  )
}
